import {Component, ElementRef, ViewChild} from '@angular/core';
import {WrapperComponent} from '../../shared/wrapper/wrapper.component';
import {CommonHeaderComponent} from '../../components/common-header/common-header.component';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {TalentPoolService} from '../../core/services/talentpool-service/talentPool.service';
import {Consultant} from '../../interfaces/consultantInterfact';
import {JobSummary} from '../../interfaces/talentPoolInterface';
import {ToastService} from '../../core/services/toast-service/ToastService';
import {Card} from 'primeng/card';
import {Tag} from 'primeng/tag';
import {PrimeTemplate} from 'primeng/api';
import html2canvas from 'html2canvas-pro';
import jsPDF from 'jspdf'

@Component({
  selector: 'app-consultant-detial-user',
  imports: [
    Card,
    CommonHeaderComponent,
    ReactiveFormsModule,
    Tag,
    WrapperComponent,
    PrimeTemplate
  ],
  templateUrl: './consultant-detial-user.component.html',
  styleUrl: './consultant-detial-user.component.scss'
})

export class ConsultantDetialUserComponent {
  consultant: Partial<Consultant> | null = null;
  consultantId: string;
  consultantDetailForm: FormGroup;
  selectedJobId: string | null = null;
  jobOptions: { label: string; value: string }[] = [];
  contactId: string = '';
  showFormSection = false;
  isFavorite: boolean = false;
  @ViewChild('formSection') formSection!: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private talentPoolService: TalentPoolService,
    private fb: FormBuilder,
    private toast: ToastService,
  ) {
    this.consultantId = this.route.snapshot.paramMap.get('id')?.toString() ?? '';
    this.consultantDetailForm = this.fb.group({
      jobId: [''],
      jobDescription: [''],
      noOfOpenings: [''],
      duration: [''],
      workTimeZone: ['']
    });
  }

  ngOnInit(): void {
    if (this.consultantId) {
      this.getConsultantDetail(this.consultantId);
    }
    this.getJobSummary();
  }

  getConsultantDetail(consultantId: string): void {
    this.talentPoolService.getConsultant(consultantId).subscribe({
      next: (res: Consultant) => {
        this.consultant = res;
        this.isFavorite = res.shortlisted
      },
      error: (error) => {
        console.error('Error fetching consultant details:', error);
      }
    });
  }

  getJobSummary(): void {
    this.talentPoolService.getJobSummary().subscribe({
      next: (res: JobSummary[]) => {
        const jobList = res.map(job => ({
          label: job.jobId,
          value: job.id.toString()
        }));
        this.jobOptions = [{label: 'NONE', value: ''}, ...jobList];
        this.consultantDetailForm.patchValue({jobId: ''});
        this.selectedJobId = '';
      },
      error: (error) => {
        console.error('Error loading job summary:', error);
      }
    });
  }

  onSubmit(): void {
    const payload = {
      ...this.consultantDetailForm.value,
      jobId: this.selectedJobId ? this.selectedJobId : null,
      consultantId: this.consultantId,
      allowDuplicate: true
    };
    this.talentPoolService.addConsultantToMyList(this.contactId, payload).subscribe({
      next: () => {
        this.toast.showSuccess('Success', 'Your request has been submitted , the SPOC will get back to you in 24 hrs.');
        this.consultantDetailForm.reset();
        this.showFormSection = false;
        this.jobOptions = [{label: 'NONE', value: ''}];
        this.consultantDetailForm.patchValue({jobId: ''});
      },
      error: (error) => {
        this.toast.showError('Error', error?.error?.message)
      }
    })
  }

  handleFavClick(event: boolean) {
    if (event) {
      this.isFavorite = true;
      this.talentPoolService.addInterested(this.consultantId).subscribe((e) => {
      }, error => {
        this.isFavorite = false;
        this.toast.showError('Error', error?.error?.message);
      })
    } else {
      this.isFavorite = false;
      this.talentPoolService.removeInterested(this.consultantId).subscribe((e) => {
      }, error => {
        this.toast.showError('Error', error?.error?.message);
        this.isFavorite = true;
      })
    }
  }

  downloadFullPageAsPDF() {
    const element = document.getElementById('full-page-content');
    if (!element) return;
    const clonedElement = element.cloneNode(true) as HTMLElement;
    clonedElement.classList.add('pdf-clone');
    clonedElement.querySelectorAll('.hide-for-pdf').forEach(el => el.remove());
    clonedElement.style.position = 'absolute';
    clonedElement.style.left = '-9999px';
    clonedElement.style.top = '0';
    clonedElement.style.fontSize = '16px';
    clonedElement.style.width = '794px';
    clonedElement.style.padding = '20px';
    document.body.appendChild(clonedElement);
    html2canvas(clonedElement, {
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff'
    }).then((canvas) => {
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = 210;
      const pageHeight = 297;
      const margin = 10;
      const imgWidth = pageWidth - margin * 2;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const pageCanvasHeight = (canvas.width * (pageHeight - margin * 2)) / imgWidth;
      let pageOffset = 0;
      while (pageOffset < canvas.height) {
        const pageCanvas = document.createElement('canvas');
        pageCanvas.width = canvas.width;
        pageCanvas.height = Math.min(pageCanvasHeight, canvas.height - pageOffset);
        const ctx = pageCanvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(canvas, 0, -pageOffset);
        }
        const pageData = pageCanvas.toDataURL('image/jpeg', 1.0);
        if (pageOffset > 0) {
          pdf.addPage();
        }
        pdf.addImage(pageData, 'JPEG', margin, margin, imgWidth, (pageCanvas.height * imgWidth) / canvas.width);
        pageOffset += pageCanvasHeight;
      }
      pdf.save(`${this.consultant?.firstName ?? 'consultant'}-details.pdf`);
    }).catch((error) => {
      console.error('Error generating PDF:', error);
    }).finally(() => {
      document.body.removeChild(clonedElement);
    });
  }

}
